export default {
	SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
	SET_USER_CPF: 'SET_USER_CPF',
	SET_USER_NAME: 'SET_USER_NAME',
	SET_USER_CALLBACK: 'SET_USER_CALLBACK',
	SET_CHANGE_PASSWORD: 'SET_CHANGE_PASSWORD'
}
